import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Table, Card, Loader} from 'semantic-ui-react';
import moment from 'moment';
import {sumBy} from 'lodash';
import {dateFormatReservation} from '../../../../../common/constants/datesFormat';

class OnOrdersList extends Component {
  renderOnOrders() {
    const {loadingOnOrders, loadingSales, onOrdersList} = this.props;
    if (loadingOnOrders || loadingSales) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    if (!onOrdersList.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={6}>No hay datos</Table.Cell>
        </Table.Row>
      );
    }
    return onOrdersList.map((element, index) => {
      const dateFormatted = element.date ?
        moment(element.date).format(dateFormatReservation) :
        '';
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{element.user}</Table.Cell>
          <Table.Cell textAlign='center'>{dateFormatted.toUpperCase()}</Table.Cell>
          <Table.Cell textAlign='center'>{element.order}</Table.Cell>
          <Table.Cell textAlign='center'>{element.quantity}</Table.Cell>
          <Table.Cell textAlign='center'>{element.storedQuantity}</Table.Cell>
          <Table.Cell textAlign='center'>{element.balance}</Table.Cell>
        </Table.Row>
      );
    });
  }

  renderTotals() {
    const {onOrdersList} = this.props;
    const totalQuantity = sumBy(onOrdersList, 'quantity') || 0;
    const totalStoredQuantity = sumBy(onOrdersList, 'storedQuantity') || 0;
    const totalBalance = sumBy(onOrdersList, 'balance') || 0;
    return (
      <Table.Row className='totals-row'>
        <Table.Cell textAlign='left' colSpan={3}>TOTAL</Table.Cell>
        <Table.Cell textAlign='center'>{totalQuantity}</Table.Cell>
        <Table.Cell textAlign='center'>{totalStoredQuantity}</Table.Cell>
        <Table.Cell textAlign='center'>{totalBalance}</Table.Cell>
      </Table.Row>
    );
  }

  render() {
    return (
      <Card fluid raised>
        <div className='title-bar'>
          <div className='title'>
            <h2>On Orders</h2>
          </div>
        </div>

        <Table striped className='scrollable-body'>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell textAlign='center'>Usuario</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Fecha</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'># Pedido</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Cantidad Pedida</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Cantidad Atendida</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Saldo</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {this.renderOnOrders()}
            {this.renderTotals()}
          </Table.Body>
        </Table>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loadingOnOrders': state.partWatching.loadingOnOrders,
    'onOrdersList': state.partWatching.onOrders,
    'loadingSales': state.partWatching.loadingSales,
  };
};

export default connect(mapStateToProps, {
})(OnOrdersList);
